import React, { Component } from 'react';
import FormValidationHelper from './FormValidationHelper';

class Chen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submissionType: '',
            associatedFee: '',
            description: '',
            name: '',
            organization: '',
            email: '',
            phone: '',
            website: '',
            words: 75,
            errorMessage: '',
            submitted: false
        };
    }

    handleChange = (evt) => {
        if (evt.target.name === 'phone') {
            evt.target.value = FormValidationHelper.formatPhone(evt.target.value);
        }
        if (evt.target.name === 'description') {
            let wordCount = 75;
            let dta = evt.target.value.trim().split(' ');
            if (dta.length > 75) {
                return;
            } else if (evt.target.value !== '') {
                wordCount = 75 - dta.length;
            }
            console.log('dta:' + dta);
            console.log('dta.length:' + dta.length);
            this.setState({ "words": wordCount });
        }
        this.setState({ [evt.target.name]: evt.target.value });
    }

    validEmail = () => {
        if (!this.state.email) {
            return false;
        }
        if (!(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(this.state.email))) {
            return false;
        }
        return true;
    }

    submitCHEN = (evt) => {
        evt.preventDefault();
        fetch('/api/chen/submit', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => {
                return response.json();
            })
            .then(json => {
                console.log('json:' + json);
                if (json.success === true) {
                    this.setState({ 'submitted': true });

                } else {
                    this.setState({ 'errorMessage': json.errorMessage });
                }
            })
            .catch(error => {
                this.setState({ 'errorMessage': error.message });
            })


    }

    validate = (evt) => {
        document.getElementById('chenform').classList.add('was-validated');
    }

    reload = () => {
        this.setState({
            submissionType: '',
            associatedFee: '',
            description: '',
            name: '',
            organization: '',
            email: '',
            phone: '',
            website: '',
            words: 75,
            errorMessage: '',
            submitted: false
        });
    }

    render() {
        return (
            <div className="Chen">
                <div className="ChenContent">
                    {this.state.errorMessage &&
                        <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>
                    }
                    {this.state.submitted === true &&
                        <div>
                            <p>Thank you for your submission!</p>
                            <p>All submissions are reviewed to ensure that they are aligned with ASHA Core Beliefs, Vision, and Mission.</p>
                            <p><a href="#reload" onClick={this.reload}>Submit another CHEN</a></p>

                        </div>
                    }
                    {this.state.submitted === false &&
                        <div>
                            <h3>CHEN Submission Details</h3>
                            <hr />

                            <form id="chenform" onSubmit={this.submitCHEN}>
                                <div className="form-group">
                                    <label htmlFor="submissionType">Submission Type</label>
                                    <select className="form-control" name="submissionType" onChange={(evt) => this.handleChange(evt)} value={this.state.submissionType} required>
                                        <option value=''></option>
                                        <option value="professional_development">Professional Development</option>
                                        <option value="product_service">Product/Service</option>
                                        <option value="funding_opportunity">Funding Opportunity</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="description">Description ({this.state.words})</label>
                                    <textarea className="form-control" rows="8" name="description" onChange={(evt) => this.handleChange(evt)} value={this.state.description} required></textarea>
                                </div>
                                <br /><br />
                                <h3>Contact Information</h3>
                                <hr />
                                <div className="form-group">
                                    <label htmlFor="name">Name</label>
                                    <input className="form-control" type="text" name="name" value={this.state.name} onChange={(evt) => this.handleChange(evt)} required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">Organization</label>
                                    <input className="form-control" type="text" name="organization" value={this.state.organization} onChange={(evt) => this.handleChange(evt)} required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input className="form-control" type="email" name="email" value={this.state.email} onChange={(evt) => this.handleChange(evt)} required placeholder="you@site.com" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">Phone</label>
                                    <input className="form-control" type="tel" name="phone" value={this.state.phone} onChange={(evt) => this.handleChange(evt)} required placeholder="(ex:123-456-7890)" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">Website</label>
                                    <input className="form-control" type="text" name="website" value={this.state.website} onChange={(evt) => this.handleChange(evt)} required placeholder="(ex: http://www.ashaweb.org)" />
                                </div>
                                <br />
                                <br />
                                <h3>Questions</h3>
                                <hr />
                                <div className="form-group">
                                    <label htmlFor="fee">Is there an associated fee?</label>
                                    <select className="form-control" name="associatedFee" onChange={(evt) => this.handleChange(evt)} value={this.state.associatedFee} required>
                                        <option value=''></option>
                                        <option value='yes'>Yes</option>
                                        <option value='no'>No</option>
                                    </select>
                                </div>
                                {this.state.associatedFee === 'yes' &&
                                    <div>If yes, you may be contacted by Multiview regarding advertising options.</div>
                                }
                                <br />
                                <input type="submit" className="btn btn-primary" onClick={this.validate} value="Submit" />
                            </form>
                        </div>
                    }
                </div>

            </div>
        );
    }
}

export default Chen;
